<template>
  <div class="retireve-introduction">
    <div class="icon-title">
      <img
        :src="require('@/assets/images/SearchPage/book2.png')"
        alt="数据库介绍"
        class="icon"
      />
      数据库介绍
    </div>
    <div class="introduction-text">
      {{ brief }}
      <br />
      <br />
      <ul class="introduction-list">
        <li>
          内容精良：收录馆藏精品、遴选珍善孤本、分类全面、注重学术应用价值。
        </li>
        <li>
          原貌展现：收录古籍原版、彩色扫描图像，原汁原味展现中医古籍。
        </li>
        <li>
          分类标准：依据团体标准《中医古籍分类标准》（TCAS 531-2021）进行分类。
        </li>
        <li>
          深度标引：古籍内容的深度标引，实现古籍图片中知识的精准定位。
        </li>
        <li>
          后控检索：基于专业化的后控词表，搭建古籍知识桥梁，实现语义检索。
        </li>
        <li>
          书目提要：由专家精心撰写书目的内容提要，便于读者深入认识和阅读古籍。
        </li>
      </ul>
    </div>
    <div>
      <div class="icon-title">
        <img
          :src="require('@/assets/images/SearchPage/list2.png')"
          alt="推荐书目"
          class="icon"
        />
        推荐书目
      </div>
      <book-carousel-content
        class="recommand-book"
        :carouselData="recommandBook"
      ></book-carousel-content>
    </div>
  </div>
</template>

<script>
import BookCarouselContent from '@/components/BookCarouselContent.vue'
export default {
  name: 'RetrieveIntroduction',
  components: {
    BookCarouselContent
  },
  data () {
    return {
      recommandBook: [],
      brief: '中国中医古籍数字资源库是由中国中医科学院中医药信息研究所（图书馆）研发的大型中医古籍全文数据库，共收录15家藏书机构先秦至清末民国的历代典籍2500种。'
    }
  },
  mounted () {
    this.getRecommendBook()
    this.getSideBarInfo()
    setTimeout(() => {
      console.log('this.$global.brief', this.$global.brief)
      if (this.$route.params.url) {
        this.brief = this.$global.brief
        this.$forceUpdate()
      }
    }, 1000)
  },
  methods: {
    getRecommendBook () {
      let url = '/retrieve/search/getRecommendedBooks'
      if (this.$route.params.url) {
        url += '?libraryStrict=' + localStorage.getItem('sublibrary')
      }
      this.$http
        .get(url)
        .then(res => {
          console.log(res.data.data.searchRes)
          for (let i = 0; i < res.data.data.searchRes.length; i++) {
            let image = require('@/assets/images/bookCover/u553.jpg')
            this.recommandBook.push({
              id: res.data.data.searchRes[i].id,
              bookId: res.data.data.searchRes[i].id,
              name: res.data.data.searchRes[i].bookName,
              image: image
            })
          }
          return this.recommandBook
        })
        .then(res => {
          for (let i = 0; i < res.length; i++) {
            let url = '/retrieve/page/getImage'
            this.$http({
              method: 'get',
              url: url,
              params: {
                bookId: res[i].id,
                page: 1
              },
              responseType: 'blob'
            }).then(res1 => {
              let blob = new Blob([res1.data], { type: 'image/jpg' })
              let url = window.URL.createObjectURL(blob)
              this.recommandBook[i].image = url
            })
          }
        })
    },
    getSideBarInfo () {
      let url = '/retrieve/search/search'
      if (this.$route.params.url) {
        this.$global.originSearchDTO.libraryStrict = localStorage.getItem('sublibrary')
      }
      this.$global.searchDTO = JSON.parse(
        JSON.stringify(this.$global.originSearchDTO)
      )
      this.$global.searchDTO.userId = localStorage.getItem('userId')
      this.$global.searchDTO.returnType = 'sidebar'
      this.$http.post(url, this.$global.searchDTO).then(res => {
        this.sideBarInfo = res.data.data.sideBarInfo
        this.$bus.$emit('updateSideBarInfo', res.data.data.sideBarInfo)
      })
    }
  }
}
</script>

<style scoped>
.icon-title {
  display: flex;
  align-items: center;
  justify-content: left;
  border-bottom: 1px solid #9e5c1d;
  width: 156px;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: #9e5c1d;
}

.icon {
  width: 34px;
  margin-right: 10px;
}

.recommand-book {
  width: 880px;
  margin: 0 auto;
}

.recommand-book >>> .book-cards {
  width: 120px;
}

.recommand-book >>> .arrow {
  width: 37px;
  height: 37px;
}

.recommand-book >>> .book-title {
  margin-top: 0;
  margin: auto;
  margin-bottom: 7px;
  width: 120px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 16px;
  color: #634c37;
}

.introduction-text {
  width: 845px;
  margin: 0 auto;
  line-height: 36px;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 16px;
  color: #634c37;
  text-align: left;
}

.introduction-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.introduction-list li {
  margin: 0;
  padding: 0;
  margin-bottom: 10px;
  font-size: 16px;
  color: #634c37;
  text-align: left;
}

.introduction-list li::before {
  content: " ";
  width: 8px;
  height: 8px;
  display: inline-block;
  background-color: #9e5c1d;
  transform: rotate(45deg);
  margin-right: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/retrieve/RetrieveIntroduction.vue